const reportingReasons = {
  insulting_or_abusive_content: {
    fi: 'Loukkaava tai herjaava',
    show: true,
  },
  breaks_anonymity: {
    fi: 'Rikkoo yksityisyydensuojaa',
    show: true,
  },
  pushy_behavior: {
    fi: 'Tunkeileva tai tyrkyttävä käytös',
    show: true,
  },
  illegal: {
    fi: 'Lainvastainen',
    show: true,
  },
  not_relevant_or_unique_content: {
    fi: 'Epäolennaista tai ei-uniikkia sisältöä',
    show: true,
  },
  possible_duplicate: {
    fi: 'Mahdollinen uudelleenjulkaisu',
    show: false,
  },
  other: {
    fi: 'Muu syy',
    show: true,
  },
  unknown: {
    fi: 'Ei tiedossa',
    show: false,
  },
};

export { reportingReasons }; // eslint-disable-line
